import React, { useState, useMemo } from "react";
import "./SearchChatModal.css";
import { X, MessageCircle } from "lucide-react";
import { ChatPlusIn, ChatLines } from "iconoir-react";

const SearchChatModal = ({ visible, onClose, masterChatList = [], onSelectChat }) => {
  const [query, setQuery] = useState("");

  // ✅ Hooks harus selalu dipanggil di atas, tidak boleh setelah return
  const filteredChats = useMemo(() => {
    if (!query) return masterChatList;
    return masterChatList.filter(chat =>
      (chat.judul_chat || "").toLowerCase().includes(query.toLowerCase())
    );
  }, [query, masterChatList]);

  const groupChats = (list) => {
    const groups = { "Kemarin": [], "7 Hari Sebelumnya": [], "30 Hari Sebelumnya": [] };
    const now = new Date();

    list.forEach(chat => {
      const updated = new Date(chat.updated_at);
      const diffDays = Math.floor((now - updated) / (1000 * 60 * 60 * 24));

      if (diffDays <= 1) groups["Kemarin"].push(chat);
      else if (diffDays <= 7) groups["7 Hari Sebelumnya"].push(chat);
      else groups["30 Hari Sebelumnya"].push(chat);
    });

    return groups;
  };

  const groupedChats = useMemo(() => groupChats(filteredChats), [filteredChats]);

  // ✅ Baru setelah semua hooks dipanggil, boleh return null
  if (!visible) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        {/* Header */}
        <div className="modal-header">
          <input
            type="text"
            placeholder="Cari Obrolan..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            className="modal-search-input"
          />
          <button onClick={onClose} className="modal-close-btn">
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="modal-body">
          {/* Obrolan Baru */}
          <div style={{marginLeft:'16px'}} className="chat-item" onClick={() => onSelectChat && onSelectChat("new")}>
            <ChatPlusIn size={20} />
            <span className="chat-title-text">Obrolan Baru</span>
          </div>

          {/* Grouped chats */}
          {Object.entries(groupedChats).map(([groupName, chats]) =>
            chats.length > 0 ? (
              <div key={groupName} className="chat-group">
                <div className="chat-group-title">{groupName}</div>
                {chats.map((chat) => (
                  <div
                    key={chat.id}
                    className="chat-item"
                    onClick={() => {
                      onSelectChat && onSelectChat(chat.id);
                      onClose();
                    }}
                  >
                    <ChatLines size={18} />
                    <span className="chat-title-text">{chat.judul_chat}</span>
                  </div>
                ))}
              </div>
            ) : null
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchChatModal;